import './index.scss';
import 'raf/polyfill';
import 'core-js/es6';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import store from './store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AppContainer from 'Components/App/AppContainer';
import { unregister } from './registerServiceWorker';

ReactDOM.render(
  (
    <Provider store={ store }>
      <BrowserRouter>
        <AppContainer />
      </BrowserRouter>
    </Provider>
  ),
  document.getElementById('root') as HTMLElement,
);

unregister();


// WEBPACK FOOTER //
// ./src/index.tsx